import React from 'react';
import s from './Faq.scss';
import Listingheader from '../../../../../../src/routes/home/components/common/ListingheaderV2';
// import Image from '../../../../../components/Image';

const Faq = props => {
  const [accordianOpen, setAccordianOpen] = React.useState(0);
  const toggleAccordian = index => {
    if (index === accordianOpen) {
      setAccordianOpen('');
    } else {
      setAccordianOpen(index);
    }
  };
  const { handleFaqLayout, id = '' } = props;
  const data = props.data || [];
  const htmltagArr = ['<br>', '<ul>', '<ol>', '</a>', '<span>'];

  return (
    <>
      {data &&
        Array.isArray(data) &&
        data.length > 0 && (
          <div className={s.faqGames}>
            {!props?.title && (
              <>
                <div className={s.titleWrap}>
                  <Listingheader
                    headingname="FAQ’s"
                    subheading={data.moreText}
                  />
                </div>
              </>
            )}

            <div className={s.faqWrap}>
              <div className={s.faqInner}>
                <ul className={s.faqList}>
                  {!handleFaqLayout &&
                    data &&
                    Array.isArray(data) &&
                    data.map((item, index) => (
                      <>
                        <li onClick={() => toggleAccordian(index)}>
                          <div className={`${s.ques}`}>
                            <h5>{item.question}</h5>
                            <div className={s.arrowWrap}>
                              <i
                                className={`${s.arrowDown} ${index ===
                                  accordianOpen && s.arrowUp}`}
                              />
                            </div>
                          </div>
                          {index === accordianOpen && (
                            <div className={s.ans}>
                              <ul>
                                <li>{item.answer}</li>
                              </ul>
                            </div>
                          )}
                        </li>
                      </>
                    ))}
                  {handleFaqLayout &&
                    data &&
                    Array.isArray(data) &&
                    data.length > 0 &&
                    data.map((item, index) => (
                      <>
                        <li onClick={() => toggleAccordian(index)}>
                          <div className={`${s.ques}`}>
                            <h5>
                              {id !== 'sip_faq' ? `${index + 1}.` : ''}{' '}
                              {item.hl}
                            </h5>
                            <div className={s.arrowWrap}>
                              <i
                                className={`${s.arrowDown} ${index ===
                                  accordianOpen && s.arrowUp}`}
                              />
                            </div>
                          </div>
                          {index === accordianOpen && (
                            <div className={s.ans}>
                              {(() => {
                                const hasHtmlTag =
                                  item &&
                                  item.des &&
                                  htmltagArr.some(tag =>
                                    item.des.includes(tag),
                                  );
                                const hasListTag =
                                  item && item.des && item.des.includes('<li>');

                                if (hasHtmlTag) {
                                  if (hasListTag) {
                                    return (
                                      <span
                                        // eslint-disable-next-line react/no-danger
                                        dangerouslySetInnerHTML={{
                                          __html: item?.des,
                                        }}
                                      />
                                    );
                                  }
                                  return (
                                    <ul>
                                      <li
                                        // eslint-disable-next-line react/no-danger
                                        dangerouslySetInnerHTML={{
                                          __html: item?.des,
                                        }}
                                      />
                                    </ul>
                                  );
                                }
                                return (
                                  <ul>
                                    <li>{item?.des}</li>
                                  </ul>
                                );
                              })()}
                            </div>
                          )}
                        </li>
                      </>
                    ))}
                </ul>
              </div>
            </div>
          </div>
        )}
    </>
  );
};

export default Faq;
